import { html, TemplateResult } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { HTMLTooltipComponent } from "../controlWC/TooltipComponent";
import { UIUtilElement } from "../util/Element";
import ic_info from "/image/iconos/ic_infomark.svg?raw";

let infoIconTemplateCounter = 0;

export function _InfoIcon(parentElement: HTMLElement, tooltipText: string): HTMLTooltipComponent {
    const icInfo: HTMLElement = UIUtilElement._CreateElementFromHTML(ic_info);
    icInfo.classList.add("ic_info");
    icInfo.style.width = "var(--padding3)";
    icInfo.style.marginLeft = "var(--padding1)";
    parentElement.append(icInfo);
    const tooltip = new HTMLTooltipComponent();
    parentElement.append(tooltip);
    tooltip._SetObservedElementsAdvanced({ Target: icInfo as HTMLElement, Text: tooltipText })
    return tooltip;
}

/**
 * Plantilla de icono de información con tooltip. El tooltip se muestra al hacer hover sobre el icono.
 * @param tooltipTemplate
 * @returns
 */
export function _InfoIconTemplateWithContent(tooltipTemplate: TemplateResult<1>): TemplateResult<1> {
    if (infoIconTemplateCounter >= Number.MAX_SAFE_INTEGER) { // Reiniciar el contador si se acerca al límite para evitar problemas de rendimiento o memoria
        infoIconTemplateCounter = 0;
    }
    infoIconTemplateCounter += 1;
    const selector = `[data-info-icon-template=\"${infoIconTemplateCounter}\"]`;

    return html`
        <span
            class="ic_info"
            style="display:inline-flex;width:var(--padding3);margin-left:var(--padding1);"
            data-info-icon-template="${infoIconTemplateCounter}"
        >
            ${unsafeHTML(ic_info)}
        </span>
        <wc-tooltip observed-selection="${selector}">${tooltipTemplate}</wc-tooltip>
    `;
}

/**
 * Plantilla de icono de información con tooltip. El tooltip se muestra al hacer hover sobre el icono.
 * @param tooltipText
 * @returns
 */
export function _InfoIconTemplate(tooltipText: string): TemplateResult<1> {
    return _InfoIconTemplateWithContent(html`${tooltipText}`);
}
